<template>
    <div class="container">
        <div class="row justify-content-md-center mt-1">
            <div class="col-md-5">
                <div class="card text-center pl-3 pr-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <img src="@/assets/logo.png" width="150" alt="Logo" />
                                <hr>
                                <div class="auth-title">Login</div>
                            </div>
                        </div>
                        <div class="row justify-content-md-center">
                            <div class="col-md-12">
                                <b-form-input id="user-email" type="text"
                                    v-model="user.email"
                                    placeholder="E-mail"  v-on:keyup.enter="signin"
                                    :class="{ 'inputError': $v.user.email.$error }"
                                    class="textInput"
                                    @keydown.tab="$v.user.email.$touch"/>
                                <span class="error" v-if="!$v.user.email.required && $v.user.email.$error">Campo Obrigatório!</span>
                                <span class="error" v-if="!$v.user.email.email && $v.user.email.$error">Digite um email válido!</span>
                            </div>
                        </div>
                        <div class="row justify-content-md-center">
                            <div class="col-md-12">
                                <b-form-input id="user-senha" type="password"
                                    v-model="user.senha"
                                    placeholder="Senha" class="mt-2 textInput" v-on:keyup.enter="signin"
                                    :class="{ 'inputError': $v.user.senha.$error }"
                                    @keydown.tab="$v.user.senha.$touch"/>
                                <span class="error" v-if="!$v.user.senha.required && $v.user.senha.$error">Campo Obrigatório!</span>
                                <span class="error" v-if="!$v.user.senha.minLength && $v.user.senha.$error">Mínimo de 4 caracteres!</span>
                            </div>
                        </div>
                        <div class="row justify-content-md-center">
                            <div class="col-md-12">
                                <b-button variant="outline-info" class="mt-4 botaoInput" @click="signin">Login</b-button>
                            </div>
                        </div>
                        <div class="row justify-content-center mt-2">
                            <b-link class="small-text" to="/novoCliente">Novo aqui? Clique aqui para se cadastrar!</b-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import { VueEasyJwt } from 'vue-easy-jwt'
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
    name: 'Auth',
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            user: {},
            email: ''
        }
    },
    validations: {
        user: {
            email: {
                required,
                email
            },
            senha: {
                required,
                minLength: minLength(4)
            }
        }
    },
    methods: {
        signin() {
            axios.post(`${baseApiUrl}/backend/auth.php`, this.user)
            .then(res => {
                this.$toasted.global.defaultSuccess({ message : 'Logado com sucesso!' })
                // const decodedToken = this.jwt.decodeToken(res.data)
                localStorage.setItem('__SYSTEM_USER', JSON.stringify(res.data))
                this.$router.push({ path: '/' })
                this.$store.commit('toggleVisible', true)
                window.location.reload() 
            })
            .catch(
                (e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        }
    },
    mounted() {
    }
}
</script>

<style>
    .textInput {
        border: 1px solid rgb(220, 220, 220);
        outline: 0 !important;
        border-radius: 0px !important;
        background-color: transparent !important;
        font-size: 0.8rem !important;
    }

    .botaoInput {
        font-size: 0.8rem !important;
        border-radius: 0px !important;
    }
    .auth-title {
        font-size: 1.2rem;
        font-weight: 100;
        margin-top: 10px;
        margin-bottom: 15px;
    }

    .card input {
        border: 0;
        outline: 0;
        border-radius: 0px;
        border-bottom: 1px solid #AAA;
        background-color: transparent;
    }

    .card hr {
        border: 0;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }

    .small-text {
        font-size: 0.6rem;
        color: black;
    }

    .small-text:hover {
        font-size: 0.6rem;
        text-decoration: none;
        color: black;
    }

    
.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border-bottom: 1px solid #f57f6c !important;
}
</style>